(() => {
  const sliders = document.querySelectorAll('[data-thp-slider]');

  sliders.forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-thp-slide]')];
    const dots = [...slider.querySelectorAll('[data-thp-dot]')];
    const prev = slider.querySelector('[data-thp-prev]');
    const next = slider.querySelector('[data-thp-next]');
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = Number(slider.dataset.speed || 6000);
    let index = 0;
    let timer = null;

    function go(to) {
      if (!slides.length) return;
      index = (to + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || slides.length < 2) return;
      timer = window.setInterval(() => go(index + 1), speed);
    }

    prev?.addEventListener('click', () => { go(index - 1); start(); });
    next?.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { go(i); start(); }));

    const hasRealHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (hasRealHover) {
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
    }

    go(0);
    start();
  });
})();
document.querySelectorAll('[data-thp-slider]').forEach((slider) => {
  let startX = 0;
  let startY = 0;
  let endX = 0;

  const nextButton = slider.querySelector('[data-thp-next]');
  const prevButton = slider.querySelector('[data-thp-prev]');

  slider.addEventListener('touchstart', (event) => {
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true });

  slider.addEventListener('touchmove', (event) => {
    endX = event.touches[0].clientX;
  }, { passive: true });

  slider.addEventListener('touchend', (event) => {
    const diffX = startX - endX;
    const diffY = startY - (event.changedTouches[0]?.clientY || startY);

    if (Math.abs(diffX) < 45) return;
    if (Math.abs(diffY) > Math.abs(diffX)) return;

    if (diffX > 0) {
      nextButton?.click();
    } else {
      prevButton?.click();
    }
  }, { passive: true });
});